<template>
    <div>
        <b-card
            class="article mb-4"
            :class="{
                'collapsed': !article_visible
            }"
            no-body
        >
            <template #header>
                <div class="article-header-row d-flex align-items-start">
                    <span
                        class="collapse-icon mr-2 d-flex justify-content-center align-items-center"
                        :class="{'collapsed': !article_visible}"
                        :aria-expanded="article_visible ? 'true' : 'false'"
                        @click="toggleVisibility('visible')"
                    >
                        <span class="open">
                            <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                        </span>
                        <span class="closed">
                            <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                        </span>
                    </span>
                    <div class="article-header-title h4 mb-0 pt-3">{{ article.title }}</div>
                    <div id="exp-date-input" v-if="article">
                        <div class="expiration-controls">
                            <span class="expiration-label">Expiration Date:</span>
                            <input
                                type="date"
                                class="form-control"
                                :class="{ 'bg-danger text-white': isExpired }"
                                :value="(article.expiration_date || '').slice(0,10)"
                                @input="val => {
                                    const ymd = val.target.value
                                    const time = (article.expiration_date || '').split(' ')[1] || '00:00:00'
                                    article.expiration_date = ymd ? `${ymd} ${time}` : null
                                    updateArticleExpirationDate()
                                }"
                            />
                            <b-button
                                variant="light"
                                size="sm"
                                class="expiration-note-trigger"
                                :pressed="showExpirationDateInfoEditor"
                                :content="article.expiration_date_info ? 'Edit expiration note' : 'Add an expiration note'"
                                v-tippy="{placement: 'top'}"
                                @click="showExpirationDateInfoEditor = !showExpirationDateInfoEditor"
                            >
                                <font-awesome-icon :icon="['fad', 'edit']" fixed-width />
                            </b-button>
                        </div>
                        <div
                            v-if="showExpirationDateInfoEditor"
                            class="expiration-note-popover shadow-sm"
                        >
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <div class="small font-weight-bold mb-0">Expiration Date Info</div>
                                <b-button
                                    variant="link"
                                    size="sm"
                                    class="p-0 text-muted"
                                    @click="showExpirationDateInfoEditor = false"
                                >
                                    Close
                                </b-button>
                            </div>
                            <b-form-textarea
                                v-model="article.expiration_date_info"
                                rows="3"
                                max-rows="6"
                                :disabled="!can_update_article"
                            />
                            <div class="d-flex justify-content-end mt-2">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    :disabled="!can_update_article"
                                    @click="saveArticleExpirationDateInfo"
                                >
                                    Save
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                
            </template>

            <b-collapse
                v-model="article_visible"
                class="border-top"
                :class="article_visible ? null : 'collapsed'"
            >
                <div v-if="article_visible">
                    <div>
                        <div v-if="article">
                            <b-list-group class="student-edition" flush>
                                <b-list-group class="border-top" flush>
                                    <b-list-group-item class="article-pedigree-chart">
                                        <div class="h6 mb-0">
                                            <span
                                                class="text-dark mr-1"
                                            >
                                                Pedigree Chart
                                            </span>
                                        </div>
                                        <b-alert
                                            variant="danger"
                                            :show="!pedigree_chart || pedigree_chart && !pedigree_chart.length"
                                            class="my-2"
                                        >
                                            No Pedigree Found
                                        </b-alert>

                                        
                                        <div class="mt-2">
                                            <div>
                                                <b-list-group>
                                                    <b-list-group-item v-for="(item, index) in pedigree_chart" :key="index">
                                                        <div class="d-flex align-items-center">
                                                            <div>
                                                                <div class="text-muted">
                                                                    <small>Publication</small>
                                                                </div>
                                                                <div v-if="item.publication.id">
                                                                    <router-link :to="{path: '/publications/' + item.publication.id}" target="_blank">
                                                                        {{item.publication.sku}}
                                                                    </router-link>
                                                                </div>
                                                                <div v-else>
                                                                    {{item.publication.sku}}
                                                                </div>
                                                            </div>
                                                            <div class="mx-3 text-muted">
                                                                /
                                                            </div>
                                                            <div>
                                                                <div class="text-muted">
                                                                    <small>Week</small>
                                                                </div>
                                                                <div class="d-flex align-items-center">
                                                                    <div class="mr-1">
                                                                        <span>{{item.order_number}}.</span>
                                                                    </div>
                                                                    <div v-if="item.publication.id">
                                                                        <router-link :to="{path: '/publications/' + item.publication.id, query: { unit_id: item.id }}" target="_blank">
                                                                            <span v-if="item.title">{{item.title}}</span><span v-else class="text-muted">no title</span>
                                                                        </router-link>
                                                                    </div>
                                                                    <div v-else>
                                                                        <span v-if="item.title">{{item.title}}</span><span v-else class="text-muted">no title</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="mx-3 text-muted">
                                                                /
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <div class="text-muted">
                                                                        <small>Article</small>
                                                                    </div>
                                                                    <router-link :to="{path: '/publications/' + item.publication.id, query: { unit_id: item.id, article_id: article.id  }}" target="_blank">
                                                                        <span v-if="article.title">{{article.title}}</span><span v-else class="text-muted">no title</span>
                                                                    </router-link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </div>
                                        </div>
                                        
                                    </b-list-group-item>
                                </b-list-group>
                                <b-list-group-item
                                    v-if="!article.is_walkthrough && !article.is_rubric && !article.is_activity"
                                    class="article-body rounded-0"
                                >
                                    <div class="h6 d-flex align-items-center justify-content-between">
                                        <div>
                                            Article Body
                                            <span v-if="article.language.length"
                                                :content="'Designated Spanish version of ' + article.language[0].id + ' - ' + article.language[0].title"
                                                v-tippy="{placement: 'top'}"
                                            >
                                                <flag iso="es" />
                                            </span>
                                        </div>
                                        <div>
                                            <b-btn size="sm" variant="outline-info" @click="show_article_preview_modal = true" class="ml-2">
                                                <font-awesome-icon :icon="['fad', 'apple-alt']" fixed-width /> SWO Preview
                                            </b-btn>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <TipTap
                                                ref="article-body"
                                                v-model="article.body"
                                                :menu_items="[]"
                                                :min_height="true"
                                                :readonly="true"
                                            />
                                        </div>
                                    </div>

                                    <div class="d-flex mt-1">
                                        <div class="mr-3">
                                            <small class="text-muted">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="mr-1">Lexile:</div>
                                                    <div class="d-flex align-items-center">
                                                        <div class="d-flex align-items-center mr-1">
                                                            <div>
                                                                <span v-if="article.lexile_api_score == null">0</span>
                                                                <span v-else>{{article.lexile_api_score}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </small>
                                        </div>
                                    </div>
                                </b-list-group-item>

                                <b-list-group-item
                                    class="article-body rounded-0"
                                    v-if="article.is_activity"
                                >
                                    <div class="h6 d-flex align-items-center justify-content-between">
                                        <div>Activity Layout</div>
                                        <b-btn size="sm" variant="outline-info" @click="show_article_preview_modal = true" class="float-right ml-2">
                                            <font-awesome-icon :icon="['fad', 'apple-alt']" fixed-width /> SWO Activity Preview
                                        </b-btn>
                                    </div>

                                    <div
                                        v-for="(question, index) in article.questions"
                                        :key="index"
                                        class="mt-4"
                                    >
                                        <div class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div>
                                                    <question-content
                                                        :question="question"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-list-group-item>

                                <b-list-group-item
                                    class="article-body rounded-0"
                                    v-if="article.is_walkthrough"
                                >
                                    <div class="h6 d-flex align-items-center">
                                        <div>Walkthrough</div>
                                    </div>
                                    <b-card>
                                        <div>
                                            <carousel
                                                :walkthroughMedia="walkthrough_media"
                                                :showBottomCarousel="true"
                                                :identifier="'reader-mode'"
                                            />
                                        </div>
                                    </b-card>
                                    
                                </b-list-group-item>

                                <b-list-group-item  
                                    class="article-body rounded-0"
                                    v-if="article.is_rubric"
                                >
                                    <div class="h6 d-flex align-items-center">
                                        <div>Rubric Items</div>
                                    </div>
                                    <div
                                        v-for="(question, index) in article.questions"
                                        :key="index"
                                        class="mt-4"
                                    >
                                        <div v-if="question.type == 'media_block' || question.type == 'text_block'" class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div>
                                                    <question-content
                                                        :question="question"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-list-group-item>

                                <b-list-group-item v-if="article.is_rubric" class="rounded-0">
                                    <div class="h6 d-flex align-items-center">
                                        <div>Rubric Preview</div>
                                    </div>
                                    <div class="rubric-table rubric-table-teacher">
                                        <div
                                            v-for="(row, row_index) in rubric_table_data"
                                            :key="`rubric-${rubric_type}-row-${row_index}`"
                                            class="rubric-row"
                                        >
                                            <div v-if="rubric_type === 'Single Point Rubric'" :class="[!row_index ? 'rubric-heading' : 'rubric-cell rubric-comments']">
                                                <span v-if="!row_index">
                                                    <span class="rubric-heading-lg">Not Yet!</span>
                                                    <br/>
                                                    Evidence for not quite reaching the success criteria. (Suggestions for improvement)
                                                </span>
                                            </div>
                                            <div
                                                v-for="(cell, cell_index) in row.cells"
                                                :key="`rubric-${rubric_type}-row-${row_index}-cell-${cell_index}`"
                                                :class="[
                                                    !row_index ? 'rubric-heading' : 'rubric-cell',
                                                    rubric_type === 'Multi-Point Rubric' && !cell_index ? 'rubric-cell-multi' : '',
                                                ]"
                                            >
                                                {{ cell.text }}
                                            </div>
                                            <div
                                                class="rubric-scores"
                                                :class="[
                                                    !row_index ? 'rubric-heading' : 'rubric-cell'
                                                ]"
                                            >
                                                <span v-if="!row_index">Score</span>
                                                <span v-else>
                                                    
                                                    / <span v-if="rubric_type === 'Multi-Point Rubric'">{{ row.cells.length - 1 }}</span><span v-else>{{ row.score != null ? row.score : 1 }}</span>
                                                </span>
                                            </div>
                                            <div v-if="rubric_type === 'Single Point Rubric'" :class="[!row_index ? 'rubric-heading' : 'rubric-cell rubric-comments']">
                                                <span v-if="!row_index">
                                                    <span class="rubric-heading-lg">For Sure!</span>
                                                    <br/>
                                                    Evidence for going beyond success criteria.
                                                </span>
                                            </div>
                                        </div>
                                        <div class="rubric-row">
                                            <div v-if="rubric_type === 'Single Point Rubric'"
                                                class="rubric-scores rubric-cell"
                                            >
                                                <span>
                                                    
                                                </span>
                                            </div>
                                            <div
                                                v-for="(cell, cell_index) in rubric_table_data[0].cells"
                                                :key="`rubric-${rubric_type}-row-total-cell-${cell_index}`"
                                                :class="['rubric-cell',
                                                    rubric_type === 'Multi-Point Rubric' && !cell_index ? 'rubric-cell-multi' : '',
                                                ]"
                                            >
                                                <span v-if="cell_index === 0">Total</span>
                                            </div>
                                            <div
                                                class="rubric-scores rubric-cell"
                                            >
                                                <span v-if="rubric_type === 'Single Point Rubric'">
                                                    / {{ tableScoreTotal }}
                                                </span>
                                                <span v-else>
                                                    / {{ (rubric_table_data.length - 1) * (rubric_table_data[0].cells.length - 1) }}
                                                </span>
                                            </div>
                                            <div v-if="rubric_type === 'Single Point Rubric'"
                                                class="rubric-scores rubric-cell"
                                            >
                                                <span>
                                                    
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </b-list-group-item>

                                <b-list-group-item v-if="!article.is_walkthrough" class="rounded-0">
                                    <div class="h6">Designer Notes</div>
                                    <TipTap
                                        v-model="article.designer_notes"
                                        :menu_items="[]"
                                        :readonly="true"
                                    />
                                </b-list-group-item>

                                <b-list-group-item v-if="article.is_activity" class="article-answer-key">
                                    <div class="h6">
                                        Activity Answer Key
                                    </div>

                                    <TipTap
                                        v-model="article.activity_answer_key"
                                        :menu_items="[]"
                                        :readonly="true"
                                    />
                                </b-list-group-item>

                                <b-list-group-item v-if="!article.is_walkthrough" class="article-narration">
                                    <div class="h6">
                                        Narration
                                    </div>
                                    
                                    <div class="mt-2">
                                        <div v-if="article.narration && article.narration.url">
                                            <b-card no-body>
                                                <b-card-body>
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            <audio ref="narration-audio" class="d-flex mb-0" controls>
                                                                <source :src="secureUrl(article.narration.url)" type="audio/mpeg">
                                                                Your browser does not support the audio element.
                                                            </audio>
                                                        </div>
                                                    </div>
                                                </b-card-body>
                                            </b-card>
                                        </div>
                                    </div>
                                </b-list-group-item>

                                <b-list-group-item
                                    class="article-vocabulary"
                                    v-if="!article.is_walkthrough"
                                >
                                    <div class="h6 mb-0">
                                        <span
                                            class="text-dark mr-1"     
                                        >
                                            Vocabulary
                                        </span>
                                    </div>
                                    <div class="mt-2">
                                        <div>
                                            <div v-if="vocabulary_terms && vocabulary_terms.length">
                                                <div v-for="(vocabulary_term, index) in vocabulary_terms" :key="index">
                                                    <vocabulary-term
                                                        :article="article"
                                                        :vocabulary_term="vocabulary_term"
                                                        :vocabulary_terms="vocabulary_terms"
                                                        :readonly="true"
                                                    />
                                                </div>
                                            </div>

                                            <b-alert
                                                variant="danger"
                                                :show="!vocabulary_terms || vocabulary_terms && !vocabulary_terms.length"
                                                class="my-2"
                                            >
                                                0 Vocabulary Terms added
                                            </b-alert>
                                        </div>
                                    </div>
                                </b-list-group-item>

                                <b-list-group-item
                                    class="article-questions"
                                    v-if="!article.is_walkthrough && !article.is_rubric && !article.is_activity"
                                >
                                    <div class="h6 m-0">Article Questions
                                        <span style="position: absolute; right: 5%;">
                                            <a v-if="article.questions && article.questions.length" :href="'/questionList/article/'+article.id" target="_blank" class="pull-right" ><font-awesome-icon :icon="['fad', 'clipboard']" style="color: grey;" fixed-width /></a>
                                        </span>
                                    </div>
                                    <b-alert
                                        variant="danger"
                                        :show="!article.questions || article.questions && !article.questions.length"
                                        class="my-2"
                                    >
                                        0 Questions added
                                    </b-alert>
                                    <div
                                        v-for="(question, index) in article.questions"
                                        :key="index"
                                        class="mt-2"
                                    >
                                        <div class="d-flex align-items-center">
                                            <div class="mr-3">
                                                {{index + 1}}.
                                            </div>
                                            <div class="flex-grow-1">
                                                <div>
                                                    <question-content
                                                        :question="question"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>

                            <b-list-group v-if="!article.is_walkthrough" flush class="border-top student-edition">
                                <b-list-group-item class="rounded-0">
                                    <div class="h6">Citations</div>

                                    <TipTap
                                        v-model="article.citations"
                                        :menu_items="[]"
                                        :readonly="true"
                                    />
                                </b-list-group-item>

                                <b-list-group-item class="article-tags rounded-0">
                                    <div class="h6">Tags</div>
                                    <tag-multiselect
                                        v-model="article.tags"
                                        :options="tags"
                                        @select="addTag"
                                        @remove="removeTag"
                                        :disabled="!can_update_article"
                                    />
                                </b-list-group-item>
                            </b-list-group>

                        </div>
                    </div>
                </div>
            </b-collapse>
        </b-card>

        <article-preview-modal
            v-model="show_article_preview_modal"
            @hide="show_article_preview_modal = false"
            :article="article"
        />
    </div>
</template>


<style lang="scss" scoped>
@import '@/assets/css/_colors';

.article-header-row {
    width: 100%;
    gap: 0.75rem;
}

.article-header-title {
    flex: 1 1 auto;
    min-width: 0;
}

#exp-date-input{
    flex: 0 0 320px;
    max-width: 320px;
    margin-left: auto;
    position: relative;
}

.expiration-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
}

.expiration-label {
    white-space: nowrap;
}

.expiration-controls .form-control {
    min-width: 0;
}

.expiration-note-trigger {
    flex-shrink: 0;
}

.expiration-note-popover {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    width: 280px;
    padding: 0.75rem;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 0.25rem;
    z-index: 10;
}

.student-edition {
    .list-group-item {
        border-left: 3px solid #B2EBF2;
    }
}

.card {
    &.collapsed {
        .card-header {
            border-radius: .25rem;
        }
    }
    .card-header {
        border-bottom: 0;
    }
    .list-group {
        .list-group-item {
            &:first-child {
                // border-radius: 0;
            }

            .list-group {
                .list-group-item {
                    // border-radius: inherit;
                }
            }
        }
    }
}

// rubric preview css 

.rubric-table {
    display: table;
    border: 1px solid #666666;
    width: 100%;
    border-radius: 10px;
    margin-top: 16px;

    .rubric-row {
        display: table-row;

        .rubric-heading {
            display: table-cell;
            text-align: center;
            padding: 16px;
            border-bottom: 1px solid #666666;
            background-color: #eeeeee;

            color: var(--Gray-Dark, #666);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            border-right: 1px solid #D9D9D9;
            vertical-align: middle;

            &:first-child {
                border-top-left-radius: 10px;
            }

            &:last-child {
                border-top-right-radius: 10px;
            }

            .rubric-heading-lg {
                font-size: 20px;
            }
        }

        .rubric-cell {
            display: table-cell;
            padding: 16px;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            vertical-align: middle;
            border-right: 1px solid #D9D9D9;
            border-bottom: 1px solid #D9D9D9;

            &.rubric-cell-multi {
                font-family: Poppins;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }

            &.rubric-scores {
                text-align: center;
                font-feature-settings: 'clig' off, 'liga' off;
                /* Big Body Bold */
                font-family: Poppins;
                font-size: 16px;
                font-style: normal;
                line-height: normal;
                width: 70px;

                .rubric-scores-graded {
                    color: var(--Black, #000);
                }
            }
        }

        & > div.rubric-heading:first-child,
        & > div.rubric-cell:first-child {
            //border-right: 1px solid #000000;
            word-break: break-word;
        }
        & > div.rubric-heading:last-child,
        & > div.rubric-cell:last-child {
            border-right: 0;
        }

        &:last-child > div.rubric-cell {
            border-bottom: 0;
        }
    }
}
.rubric-table-single,
.rubric-table-multi:last-child {
    .rubric-row {
        &:last-child > .rubric-scores .rubric-scores-graded {
            font-weight: bold;
        }
    }
}

.rubric-comments {
    min-width: 270px;
}

@media (max-width: 991px) {
	.rubric-comments {
    	min-width: 125px;
}
}

.multi-rubric-comments {
    border: 1px solid #666666;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: 0;
}

.sticky-save-row {
    position: sticky;
    bottom: -19px;
    background: white;
    margin: 0;
    padding-top: 12px;
}  

</style>

<script>
import TagMultiselect from '@/components/TagMultiselect'
import { mapState } from 'vuex'
import ArticlePreviewModal from '@/components/article/SWOPreviewModal'
import TipTap from '@/components/tiptap/TipTap'
import QuestionContent from '@/components/questions/Index'
import VocabularyTerm from '@/components/article/VocabularyTerm'
import Carousel from '@/components/Carousel.vue'

export default {
    data: () => ({

        question: {},

        show_article_preview_modal: false,

        showExpirationDateInfoEditor: false,

        article_visible: true,

    }),
    props: [
        'article',
        'vocabulary_terms',
        'pedigree_chart',
        'walkthrough_media',
        'rubric_table_data',
        'rubric_type'
    ],
    components: {
        TagMultiselect,
        ArticlePreviewModal,
        QuestionContent,
        TipTap,
        VocabularyTerm,
        Carousel
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            tags: state => state.tags.tags,
        }),
        can_update_article() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_article')
        },
        tableScoreTotal() {
			let totalScore = 0;
			// loop over table data starting at i = 1 to skip header row
			for (let i = 1; i < this.rubric_table_data.length; i++) {
				const scoreToAdd = this.rubric_table_data[i].score != null ? this.rubric_table_data[i].score : 1;
				totalScore += parseInt(scoreToAdd)
			}
			return totalScore
		},
        isExpired() {
            const expirationDate = this.article && this.article.expiration_date;
            if (!expirationDate) {
                return false;
            }
            // Compare at end-of-day local time so a same-day date isn’t marked expired prematurely
            const [ymd] = String(expirationDate).split(' ');
            if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
                 return false;
            }
            const endOfDay = new Date(`${ymd}T23:59:59`);

            return !isNaN(endOfDay) && Date.now() > endOfDay.getTime();
        },
        can_view_deprecated_fields() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'view_deprecated_fields');
        },
    },
    watch: {  

    },
    methods: {
        secureUrl(url){
            return url.replace("http:", "https:")
        },
        toggleVisibility (value) {
            this.article_visible = !this.article_visible
        }, 
        async saveArticleExpirationDateInfo() {
            await this.updateArticleExpirationDate()
            this.showExpirationDateInfoEditor = false
        },
        async updateArticleExpirationDate(){
            try {
                await this.axios.post('/api/articles/update_expiration_date/' + this.article.id, {
                    expiration_date: this.article.expiration_date,
                    expiration_date_info: this.article.expiration_date_info || null,
                })
                .then(response => {
                    if (response.data) {
                        this.$set(this.article, 'expiration_date', response.data.expiration_date);
                        this.$set(this.article, 'expiration_date_info', response.data.expiration_date_info);
                    }
                })
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to update article expiration date: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.$emit('updatedExpiration');
                this.$emit('hide');
            }
        },
        async addTag(tag) {
            try{
                await this.axios.post('/api/articles/add_tag/' + this.article.id, {
                    tag_id: tag.id
                })
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to update article tag: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.$emit('updateSearch');
            }
        },
        async removeTag(tag) {
            try{
                await this.axios.post('/api/articles/remove_tag/' + this.article.id, {
                    tag_id: tag.id
                })
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to remove article tag: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.$emit('updateSearch');
            }
        },
    },  
}
</script>
